import isPropValid from '@emotion/is-prop-valid';
import { keyframes } from '@emotion/react';

export const getKeyframeFrom = (animationStr) => keyframes`${animationStr}`;

export const hexColorOpacity = (hexColor, opacity) =>
  `${hexColor}${opacity}`.trim();

export const defaultExcludedProps = [
  'color',
  'display',
  'height',
  'open',
  'order',
  'overflow',
  'loading',
  'width',
];

// Forward commonly valid HTML props but don't render `styled-system`
// props like `width`, `loading`, `color`, etc. to HTML
export const forwardValidProp = (prop, propsToExclude = defaultExcludedProps) =>
  isPropValid(prop) && !propsToExclude.includes(prop);
